import { defineMessages } from 'react-intl';

export const messages: {
	loginButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loginAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userAccountMenuAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	teamworkGraphBrand: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	navAbout: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	navConnectors: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	navCli: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	navMcp: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	navDocs: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	navYourGraph: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	profileLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	logoutLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sendFeedback: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	logoAlt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	loginButton: {
		id: 'twg-microsite.navbar.loginButton',
		defaultMessage: 'Log in',
		description: 'Button to log in to the application',
	},
	loginAriaLabel: {
		id: 'twg-microsite.navbar.loginAriaLabel',
		defaultMessage: 'Log in',
		description: 'Accessible label for the log in button',
	},
	userAccountMenuAriaLabel: {
		id: 'twg-microsite.navbar.userAccountMenuAriaLabel',
		defaultMessage: 'Account menu, {userName}',
		description:
			'Accessible label for the signed-in user avatar that opens the account menu. {userName} is the user display name.',
	},
	teamworkGraphBrand: {
		id: 'twg-microsite.navbar.teamworkGraphBrand',
		defaultMessage: 'Atlassian Teamwork Graph',
		description: 'Teamwork Graph brand name shown in the nav bar',
	},
	navAbout: {
		id: 'twg-microsite.navbar.navAbout',
		defaultMessage: 'About',
		description: 'Navigation link to the About section of the microsite',
	},
	navConnectors: {
		id: 'twg-microsite.navbar.navConnectors',
		defaultMessage: 'Connectors',
		description: 'Navigation link to the Connectors section of the microsite',
	},
	navCli: {
		id: 'twg-microsite.navbar.navCli',
		defaultMessage: 'CLI',
		description: 'Navigation link to the CLI section of the microsite',
	},
	navMcp: {
		id: 'twg-microsite.navbar.navMcp',
		defaultMessage: 'MCP',
		description:
			'Navigation link to the Getting Started section of the microsite, pre-selecting the MCP install instructions tab',
	},
	navDocs: {
		id: 'twg-microsite.navbar.navDocs',
		defaultMessage: 'Docs',
		description: 'Navigation link to the documentation section of the microsite',
	},
	navYourGraph: {
		id: 'twg-microsite.navbar.navYourGraphs',
		defaultMessage: 'Your Graph',
		description: 'Navigation link to the Your Graphs section of the microsite',
	},
	profileLabel: {
		id: 'twg-microsite.navbar.profileLabel',
		defaultMessage: 'Profile',
		description: 'Label and icon label for the Profile menu item in the user dropdown',
	},
	logoutLabel: {
		id: 'twg-microsite.navbar.logoutLabel',
		defaultMessage: 'Logout',
		description: 'Label and icon label for the Logout menu item in the user dropdown',
	},
	sendFeedback: {
		id: 'twg-microsite.navbar.sendFeedback',
		defaultMessage: 'Send feedback',
		description: 'Label for feedback trigger in the navbar',
	},
	logoAlt: {
		id: 'twg-microsite.navbar.logoAlt',
		defaultMessage: 'Teamwork Graph logo',
		description: 'Accessible label for the Teamwork Graph logo',
	},
});
